/** Dependency-free: imported by build configs (Vite) and by theme.ts. */

export const THEME_STORAGE_KEY = "agencyos.theme";

/**
 * Inline this in <head>, before any CSS paints: it applies the theme and the glass fallback
 * synchronously, so there is never a flash of the wrong theme (P0-08).
 */
export const NO_FLASH_SCRIPT = `(function(){try{var p=localStorage.getItem("agencyos.theme")||"auto";var d=p==="dark"||(p==="auto"&&matchMedia("(prefers-color-scheme: dark)").matches);document.documentElement.setAttribute("data-theme",d?"dark":"light");}catch(e){}try{var n=navigator,c=n.connection||{};if((n.deviceMemory&&n.deviceMemory<=2)||(n.hardwareConcurrency&&n.hardwareConcurrency<=2)||c.saveData||matchMedia("(prefers-reduced-transparency: reduce)").matches){document.documentElement.classList.add("ao-no-glass");}}catch(e){}})();`;
